module.exports = __webpack_public_path__ + "static/img/item3.78d951d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item3.png
// module id = dXnt
// module chunks = 1